var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.6667C12 13.034 11.7013 13.3334 11.3333 13.3334H4.66668C4.29868 13.3334 4.00001 13.034 4.00001 12.6667V5.33337H12V12.6667ZM6.66668 2.88537C6.66668 2.78204 6.80934 2.66671 7.00001 2.66671H9.00001C9.19068 2.66671 9.33334 2.78204 9.33334 2.88537V4.00004H6.66668V2.88537ZM14 4.00004H13.3333H10.6667V2.88537C10.6667 2.02937 9.91934 1.33337 9.00001 1.33337H7.00001C6.08068 1.33337 5.33334 2.02937 5.33334 2.88537V4.00004H2.66668H2.00001C1.63334 4.00004 1.33334 4.30004 1.33334 4.66671C1.33334 5.03337 1.63334 5.33337 2.00001 5.33337H2.66668V12.6667C2.66668 13.7694 3.56401 14.6667 4.66668 14.6667H11.3333C12.436 14.6667 13.3333 13.7694 13.3333 12.6667V5.33337H14C14.3667 5.33337 14.6667 5.03337 14.6667 4.66671C14.6667 4.30004 14.3667 4.00004 14 4.00004Z",
    fill: "#8A8A8A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_592_9485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.6667C12 13.034 11.7013 13.3334 11.3333 13.3334H4.66668C4.29868 13.3334 4.00001 13.034 4.00001 12.6667V5.33337H12V12.6667ZM6.66668 2.88537C6.66668 2.78204 6.80934 2.66671 7.00001 2.66671H9.00001C9.19068 2.66671 9.33334 2.78204 9.33334 2.88537V4.00004H6.66668V2.88537ZM14 4.00004H13.3333H10.6667V2.88537C10.6667 2.02937 9.91934 1.33337 9.00001 1.33337H7.00001C6.08068 1.33337 5.33334 2.02937 5.33334 2.88537V4.00004H2.66668H2.00001C1.63334 4.00004 1.33334 4.30004 1.33334 4.66671C1.33334 5.03337 1.63334 5.33337 2.00001 5.33337H2.66668V12.6667C2.66668 13.7694 3.56401 14.6667 4.66668 14.6667H11.3333C12.436 14.6667 13.3333 13.7694 13.3333 12.6667V5.33337H14C14.3667 5.33337 14.6667 5.03337 14.6667 4.66671C14.6667 4.30004 14.3667 4.00004 14 4.00004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_592_9485)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 16,
    height: 16,
    fill: "#8A8A8A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.ecbe42b7eb95b50c85f7f777225dd4a5.svg";
export { ForwardRef as ReactComponent };